import React from 'react';
import { GridItem } from '@chakra-ui/react';
import { getStateName } from 'utils/address';
import { viewPercentage } from 'utils/number';
import { useGetDaystoCloseQuery } from 'reducers/open.service';
import { getDaysToClose } from 'utils/index';

const PropertyDetailsCard = ({ data }) => {
    const { data: records } = useGetDaystoCloseQuery();

    return (
        <GridItem >
            <div className='preview-box'>
                <div className="preview-heading">
                    <p>Property Details  </p>
                </div>
                <div className='preview-body' >
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    Property Type
                                </td>
                                <td>
                                    { data.property.propertyType || 'N/A'}
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    Occupany Type
                                </td>
                                <td>
                                    { data.property.OccupencyType || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Debt Ratio
                                </td>
                                <td>
                                    { viewPercentage(data.property.debtRatio) }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Days to Close
                                </td>
                                <td>
                                    { getDaysToClose(data.daysToCloseCat, records) || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    State
                                </td>
                                <td>
                                    { getStateName(data.property.Address.State) }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Zip Code
                                </td>
                                <td>
                                    { data.property.Address.Zipcode || 'N/A'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </GridItem>
    );
};

export default PropertyDetailsCard;
